import React, {useEffect} from "react";
import SubmittedDataTable from "../components/common/table/SubmittedDataTable";
import SubHeader from "../components/header/SubHeader";
import {useDispatch, useSelector} from "react-redux";
import {fetchAllFormFieldsData} from "../store/dashboard-slice";


const Dashboard = () => {
    const dispatch = useDispatch();
    const {items, fetchStatus, error} = useSelector((state) => state.dashboard);

    useEffect(() => {
        dispatch(fetchAllFormFieldsData())
    }, [dispatch]);


    return (
        <>
            <SubHeader title="Dashboard"/>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" && (
                <SubmittedDataTable data={items}/>
            )}
        </>
    );
};

export default Dashboard;
